import React, { useState } from 'react';

export const MORE_SECTIONS = [
  { id: 'timetable', label: 'Full Timetable' },
  { id: 'attendance', label: 'Attendance Record' },
  { id: 'marksheet', label: 'Results' },
  { id: 'materials', label: 'Study Materials' },
  { id: 'courses', label: 'Online Courses' },
  { id: 'library', label: 'Library' },
  { id: 'behavior', label: 'Behavior' },
  { id: 'history', label: 'Academic History' },
  { id: 'teacher', label: 'Class Teacher' },
  { id: 'idcard', label: 'ID Card' },
  { id: 'games', label: 'Games' }
];

export const shortDate = (v) => {
  const d = new Date(v);
  return isNaN(d) ? '' : d.toLocaleDateString('en-IN', { day: 'numeric', month: 'short' });
};

const Section = ({ title, action, children }) => (
  <section className="sh-card">
    <div className="sh-card-head">
      <h2>{title}</h2>
      {action}
    </div>
    {children}
  </section>
);

const plural = (n, w) => `${n} ${w}${n === 1 ? '' : 's'}`;

export function TodayTab({ periods, timetableLoaded, todaysEvents, todaysHomework, homework, fileCount, noticeCount, marksheet, year, todayYmd, go, openSection, viewMarksheet, pct, classRank, diaryCount }) {
  const dateLabel = new Date().toLocaleDateString('en-IN', { weekday: 'long', day: 'numeric', month: 'short' });
  const categories = [
    {
      title: 'Daily Studies & Routine',
      items: [
        { icon: '📅', title: "Today's Timetable", sub: periods.length ? plural(periods.length, 'period') + ' today' : 'No classes today', onClick: () => openSection('timetable') },
        { icon: '📝', title: 'Homework & Classwork', sub: `${plural(todaysHomework.length, 'task')} today · ${homework.length} total`, onClick: () => go('homework') },
        { icon: '📖', title: 'Student Diary & Notes', sub: plural(diaryCount, 'entry').replace('entrys', 'entries'), onClick: () => go('diary') },
        { icon: '📊', title: 'My Attendance Calendar', sub: pct !== null ? `${pct}% present` : 'Monthly record', onClick: () => openSection('attendance') }
      ]
    },
    {
      title: 'Academic & Exam Resources',
      items: [
        { icon: '📄', title: 'Question Papers & Worksheets', sub: plural(fileCount, 'file'), onClick: () => go('papers') },
        { icon: '🖨️', title: 'Report Card & Marksheet', sub: marksheet ? year : 'Not published', onClick: () => (marksheet ? viewMarksheet() : openSection('marksheet')) },
        { icon: '📈', title: 'My Performance', sub: 'Attendance & homework 360°', onClick: () => openSection('performance') },
        { icon: '🏆', title: 'Class Rank & Progress', sub: classRank ? `Rank: ${classRank}` : 'View progress', onClick: () => openSection('history') },
        { icon: '📚', title: 'Digital Library & Content', sub: 'Books, PDFs, videos', onClick: () => openSection('library') }
      ]
    },
    {
      title: 'School Connect & Notices',
      items: [
        { icon: '📢', title: 'Circulars & Notice Board', sub: plural(noticeCount, 'notice'), onClick: () => go('notices') },
        { icon: '🌟', title: 'Behavior & Achievements', sub: 'Badges & feedback', onClick: () => openSection('behavior') },
        { icon: '👤', title: 'My Profile & Settings', sub: 'Details & password', onClick: () => go('profile') },
        { icon: '🧑‍🏫', title: 'Class Teacher', sub: 'Contact details', onClick: () => openSection('teacher') }
      ]
    },
    {
      title: 'Learn & Play',
      items: [
        { icon: '🎓', title: 'Online Courses', sub: 'Lessons & links', onClick: () => openSection('courses') },
        { icon: '🗂️', title: 'Study Materials', sub: 'Class content', onClick: () => openSection('materials') },
        { icon: '🪪', title: 'Digital ID Card', sub: 'View / download', onClick: () => openSection('idcard') },
        { icon: '🎮', title: 'Games', sub: 'Learn with fun', onClick: () => openSection('games') }
      ]
    }
  ];
  return (
    <>
      <Section title="Today's Agenda" action={<span className="sh-muted">{dateLabel}</span>}>
        {todaysEvents.map((e) => (
          <div className="sh-alert" key={e._id || e.title}>📝 {e.title}</div>
        ))}
        {todaysHomework.length > 0 && (
          <div className="sh-alert">📚 {todaysHomework.length} homework item{todaysHomework.length > 1 ? 's' : ''} given today</div>
        )}
        {periods.length > 0 ? (
          <ul className="sh-list">
            {periods.map((p, i) => (
              <li key={i} className="sh-row">
                <span className="sh-row-title">{p.name}: {p.subject}</span>
                <span className="sh-muted">{p.time}</span>
              </li>
            ))}
          </ul>
        ) : (
          <p className="sh-empty">{timetableLoaded ? 'No classes today.' : 'Timetable not available yet.'}</p>
        )}
      </Section>

      {categories.map((cat) => (
        <section key={cat.title} className="sh-cat">
          <h2 className="sh-cat-title">{cat.title}</h2>
          <div className="sh-tiles">
            {cat.items.map((it) => (
              <button key={it.title} className="sh-tile" onClick={it.onClick}>
                <span className="sh-tile-icon" aria-hidden="true">{it.icon}</span>
                <span className="sh-tile-title">{it.title}</span>
                <span className="sh-muted">{it.sub}</span>
              </button>
            ))}
          </div>
        </section>
      ))}

      {homework.length > 0 && (
        <Section title="Recent Homework" action={<button className="sh-link" onClick={() => go('homework')}>View all</button>}>
          <ul className="sh-list">
            {homework.slice(0, 3).map((h) => (
              <li key={h._id} className="sh-row sh-row-top">
                <div>
                  <div className="sh-row-title">{h.subject}</div>
                  <div className="sh-text">{h.message}</div>
                </div>
                <span className="sh-tag">{h.date === todayYmd ? 'Today' : shortDate(h.date)}</span>
              </li>
            ))}
          </ul>
        </Section>
      )}
    </>
  );
}

export function PapersTab({ files, hrefFor }) {
  return (
    <Section title="Question Papers & Worksheets">
      {files.length === 0 ? (
        <p className="sh-empty">No files shared with your class yet.</p>
      ) : (
        <ul className="sh-list">
          {files.map((f) => (
            <li key={f._id} className="sh-row sh-row-top">
              <div>
                <div className="sh-row-title">{f.title}</div>
                <div className="sh-muted">{shortDate(f.createdAt)}{f.uploadedBy?.name ? ` · ${f.uploadedBy.name}` : ''}</div>
                <span className="sh-tag">{f.type || 'material'}</span>
              </div>
              <a className="sh-btn" href={hrefFor(f)} target="_blank" rel="noopener noreferrer" download>Download</a>
            </li>
          ))}
        </ul>
      )}
    </Section>
  );
}

export function NoticesTab({ announcements }) {
  const [openId, setOpenId] = useState(null);
  return (
    <Section title="School Circulars & Notices">
      {announcements.length === 0 ? (
        <p className="sh-empty">No notices yet.</p>
      ) : (
        <ul className="sh-list">
          {announcements.map((a) => {
            const open = openId === a._id;
            return (
              <li key={a._id} className="sh-notice" onClick={() => setOpenId(open ? null : a._id)}>
                <div className="sh-row sh-row-top">
                  <div className="sh-row-title">{a.title || (a.type === 'school' ? 'School Notice' : 'Class Notice')}</div>
                  <span className="sh-muted">{shortDate(a.createdAt)}</span>
                </div>
                <div className={open ? 'sh-text' : 'sh-text sh-clamp'}>{a.message}</div>
                {open && <div className="sh-muted">By {a.createdBy} · {a.type === 'school' ? 'Whole school' : `Class ${a.class}`}</div>}
              </li>
            );
          })}
        </ul>
      )}
    </Section>
  );
}

export function ProfileTab({ user, userProfile, pct, attended, total, openSection, onChangePassword, onLogout }) {
  return (
    <>
      <Section title="My Profile">
        <div className="sh-row"><span className="sh-muted">Name</span><span>{user.name}</span></div>
        <div className="sh-row"><span className="sh-muted">Class</span><span>{user.class}</span></div>
        {userProfile?.email && <div className="sh-row"><span className="sh-muted">Email</span><span>{userProfile.email}</span></div>}
        {pct !== null && <div className="sh-row"><span className="sh-muted">Attendance</span><span>{pct}% ({attended}/{total} days)</span></div>}
        <div className="sh-actions">
          <button className="sh-btn sh-btn-outline" onClick={onChangePassword}>Change Password</button>
          <button className="sh-btn sh-btn-danger" onClick={onLogout}>Logout</button>
        </div>
      </Section>
      {(userProfile?.fathersName || userProfile?.mothersName || userProfile?.parentContact) && (
        <Section title="Parent Information">
          {userProfile.fathersName && <div className="sh-row"><span className="sh-muted">Father</span><span>{userProfile.fathersName}</span></div>}
          {userProfile.mothersName && <div className="sh-row"><span className="sh-muted">Mother</span><span>{userProfile.mothersName}</span></div>}
          {userProfile.parentContact && <div className="sh-row"><span className="sh-muted">Contact</span><span>{userProfile.parentContact}</span></div>}
        </Section>
      )}
    </>
  );
}

export function DiaryTab({ assignments }) {
  return (
    <Section title="Student Diary & Notes">
      {assignments.length === 0 ? (
        <p className="sh-empty">No diary entries yet.</p>
      ) : (
        <ul className="sh-list">
          {assignments.map((a, i) => (
            <li key={a._id || i} className="sh-row sh-row-top">
              <div>
                <div className="sh-row-title">{a.subject}</div>
                <div className="sh-text">{a.assignment}</div>
                {a.addedBy && <div className="sh-muted">By {a.addedBy}</div>}
              </div>
              <span className="sh-tag">{shortDate(a.date)}</span>
            </li>
          ))}
        </ul>
      )}
    </Section>
  );
}
export function HomeworkTab({ homework, todayYmd }) {
  return (
    <Section title="Homework & Assignments">
      {homework.length === 0 ? (
        <p className="sh-empty">No homework yet.</p>
      ) : (
        <ul className="sh-list">
          {homework.map((h) => (
            <li key={h._id} className="sh-row sh-row-top">
              <div>
                <div className="sh-row-title">{h.subject}</div>
                <div className="sh-text">{h.message}</div>
              </div>
              <span className="sh-tag">{h.date === todayYmd ? 'Today' : shortDate(h.date)}</span>
            </li>
          ))}
        </ul>
      )}
    </Section>
  );
}